var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 4.5H30.75C31.1625 4.5 31.5 4.8375 31.5 5.25V9H16.5V5.25C16.5 4.8375 16.8375 4.5 17.25 4.5ZM12 5.25V9H6C2.69063 9 0 11.6906 0 15V24H18H30H48V15C48 11.6906 45.3094 9 42 9H36V5.25C36 2.35313 33.6469 0 30.75 0H17.25C14.3531 0 12 2.35313 12 5.25ZM48 27H30V30C30 31.6594 28.6594 33 27 33H21C19.3406 33 18 31.6594 18 30V27H0V39C0 42.3094 2.69063 45 6 45H42C45.3094 45 48 42.3094 48 39V27Z",
    fill: "#8DAF61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseSolid1);
export default __webpack_public_path__ + "static/media/briefcase-solid 1.8d4e2b3f893ea1c2becc74ecbf26cc72.svg";
export { ForwardRef as ReactComponent };